import packageTracking from './packageTracking'
import vipOceanOrder from './vipOceanOrder'

export default {
  packageTracking,
  vipOceanOrder
}
